export enum DarkMode {
    DARK = 'dark',
    LIGHT = 'light'
}